/*

NOVATIZE - Header Menu [START]

An animated header menu that is working with details/summary.

*/
class NovaHeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.detailsWrapper = document.querySelector(".header__inline-menu");
    this.mainDetailsToggle = this.querySelector("details");
    this.summary = this.mainDetailsToggle.querySelector("summary");
    this.header = document.querySelector(".header-wrapper");
    this.body = document.querySelector("body");

    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    this.summary.addEventListener("click", this.onClick.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onClick() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (!this.mainDetailsToggle.hasAttribute("open")) {
      this.body.classList.add("overflow-hidden");
      if (!this.detailsWrapper.classList.contains("header__inline-menu--open")) {
        this.detailsWrapper.classList.add("header__inline-menu--open");
      }
      this.summary.setAttribute("aria-expanded", false);
      this.querySelector(".mega-menu__list").animate(
        [
          // keyframes
          {transform: "translateX(-40vw)"},
          {transform: "translateX(0)"},
        ],
        {
          // timing options
          duration: 500,
          iterations: 1,
        },
      );
    } else {
      this.close();
    }
  }
  close() {
    this.body.classList.remove("overflow-hidden");
    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute("open");
    });
    this.summary.setAttribute("aria-expanded", false);
    this.detailsWrapper.classList.remove("header__inline-menu--open");
  }
}

customElements.define("nova-header-menu", NovaHeaderMenu);

// NOVATIZE - Header Menu [END]
